import React from 'react';
import { Container, Grid } from '@mui/material';

const IntroDatosChile = () => {
  return (
    <Container maxWidth="lg" sx={{ my: 5 }}>
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        {/* Aquí podrías agregar contenido más adelante si lo necesitas */}
      </Grid>
    </Container>
  );
};

export default IntroDatosChile;
